import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Suspense, lazy } from "react";
import { useRecordContext } from "react-admin";
import { Box } from "@mui/material";
import { ListIpAddress } from "@/resources/ElectionEvent/ListIpAddress";
import { FailedSealsBanner } from "@/components/dashboard/FailedSealsBanner";
import { monitoringLock } from "@/components/monitoring/useMonitoringPermissions";
import { VoterPortalLinks } from "@/components/dashboard/election-event/VoterPortalLinks";
var DashboardElectionEvent = lazy(function () { return import("@/components/dashboard/election-event/Dashboard"); });
var MonitoringDashboardTab = lazy(function () {
    return import("@/components/monitoring/MonitoringDashboardTab").then(function (m) { return ({
        default: m.MonitoringDashboardTab,
    }); });
});
export var ElectionEventDashboardTab = function (_a) {
    var refreshRef = _a.refreshRef, handleChildMount = _a.handleChildMount;
    var record = useRecordContext();
    var lock = monitoringLock(record);
    return (_jsx(Suspense, { fallback: _jsx("div", { children: "Loading Dashboard..." }), children: _jsxs(Box, { sx: { width: "100%", minWidth: 0 }, children: [_jsx(FailedSealsBanner, { electionEventId: record === null || record === void 0 ? void 0 : record.id, presentation: record === null || record === void 0 ? void 0 : record.presentation }), _jsx(MonitoringDashboardTab, { electionEventId: record === null || record === void 0 ? void 0 : record.id, lock: lock, footer: _jsxs(_Fragment, { children: [_jsx(VoterPortalLinks, { electionEvent: record }), _jsx(ListIpAddress, {})] }), legacy: _jsx(Box, { sx: { overflowX: "auto" }, children: _jsx(DashboardElectionEvent, { refreshRef: refreshRef, onMount: handleChildMount }) }) })] }) }));
};
